var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-2 mp-ckEditor-wrapper",class:{'ck-error': _vm.showError}},[_c('textarea',{attrs:{"id":_vm.editorId,"name":_vm.editorId,"rules":_vm.rules,"rows":"10","cols":"80"}})])}
var staticRenderFns = []

export { render, staticRenderFns }